<template>
  <el-button @click="handleUploadLog">上传日志</el-button>
</template>

<script>
import { forceFlushLogs } from "@saas/components/src/utils/log";
export default {
  components: {},
  name: "LogComponent",
  props: {},
  data() {
    return {
      uploading: false,
      isElectron: window.isElectron,
    };
  },
  methods: {
    // 上传日志
    async handleUploadLog() {
      try {
        this.uploading = true;

        if (!this.isElectron || !window.LiveElectronApi) {
          this.$darkMessage.warning("仅支持在客户端中上传");
          this.uploading = false;
          return;
        }

        // 获取日志路径
        const logPath = await window.LiveElectronApi.getLogPath();
        if (!logPath) {
          this.$darkMessage.error("获取日志路径失败");
          this.uploading = false;
          return;
        }

        // 准备上传参数
        const fileName = "LiteAV_C_" + this.getDate();
        const userId = this.$store.getters.user?.user_id || "";

        console.log("开始上传日志到 COS:", {
          folderPath: logPath,
          fileName,
          userId,
        });

        // 调用主进程上传方法（主进程直接使用 COS SDK，不需要签名）
        const result = await window.LiveElectronApi.uploadLogFiles({
          folderPath: logPath,
          fileName: fileName,
          userId: userId,
        });

        console.log("上传结果:", result);

        // 根据结果显示消息
        if (result.success) {
          if (result.failCount === 0) {
            this.$darkMessage.success("上传成功");
            this.$emit("uploadSuccess");
          } else {
            this.$darkMessage.warning("上传失败");
          }
        } else {
          this.$darkMessage.error(result.message || "上传失败");
        }
      } catch (error) {
        console.error("上传日志失败:", error);
        this.$darkMessage.error("上传日志失败");
      } finally {
        this.uploading = false;
        forceFlushLogs();
      }
    },

    // 获取日期 转成YYYYMMDD格式
    getDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}${month}${day}`;
    },
  },
};
</script>

<style scoped lang="scss">
.log-upload-button {
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;
  font-size: 12px;
  color: #c9cdd4;
}
</style>
